import { variables } from "../data/variables";

export const isMobile = () => {
  return window.innerWidth <= variables.breakpoints.s;
};
